<script>
	import { onMount } from "svelte";

	export let rating;

	const style = "";
	const config = {};

	let StarRating = null;

	const load = async () => {
		StarRating = (await import("./StarRating/StarRating.svelte")).default;
	};

	onMount(() => {
		if ("requestIdleCallback" in window) {
			requestIdleCallback(load, { timeout: 2000 });
		} else {
			setTimeout(load, 250);
		}
	});
</script>

{#if StarRating && !isNaN(rating)}
	<svelte:component this={StarRating} {rating} {style} {config} />
{/if}
